module.exports = __webpack_public_path__ + "static/media/writing_big.7df68507.gif";